import { Box, Grid, Chip } from '@mui/material';
import moment from 'moment';
import { PaqueteBitacora } from '../../../interfaces/Prestaciones.interface';

const TIPO_CONFIG: Record<string, { label: string; bg: string }> = {
  CREACION:     { label: 'Creación',     bg: '#c8e6c9' },
  EDICION:      { label: 'Edición',      bg: '#bbdefb' },
  ACTIVACION:   { label: 'Activación',   bg: '#c8e6c9' },
  DESACTIVACION:{ label: 'Desactivación',bg: '#ffccbc' },
  ELIMINACION:  { label: 'Eliminación',  bg: '#eeeeee' },
};

interface PackageHistoryTimelineRowProps {
  event: PaqueteBitacora;
  color: 'blue' | 'dark-blue';
}

const parseFecha = (fecha: string) => {
  const num = Number(fecha);
  return !isNaN(num) && fecha.trim() !== '' ? moment.utc(num) : moment.utc(fecha);
};

type DiffPart =
  | { kind: 'diff'; field: string; from: string; to: string }
  | { kind: 'plain'; text: string };

const parseDescripcion = (desc: string): DiffPart[] =>
  desc
    .split(' | ')
    .map(s => s.trim())
    .filter(Boolean)
    .map(part => {
      const arrowIdx = part.indexOf(' → ');
      const asciiIdx = part.indexOf(' -> ');
      const idx = arrowIdx !== -1 ? arrowIdx : asciiIdx;
      if (idx === -1) return { kind: 'plain' as const, text: part };
      const arrow = arrowIdx !== -1 ? ' → ' : ' -> ';
      const colonIdx = part.indexOf(': ');
      if (colonIdx === -1 || colonIdx > idx) return { kind: 'plain' as const, text: part };
      return {
        kind: 'diff' as const,
        field: part.slice(0, colonIdx),
        from:  part.slice(colonIdx + 2, idx),
        to:    part.slice(idx + arrow.length),
      };
    });

const DescripcionDiff = ({ descripcion }: { descripcion: string }) => {
  const parts = parseDescripcion(descripcion);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', mt: '2px' }}>
      {parts.map((part, i) =>
        part.kind === 'plain' ? (
          <p key={i} className="description-title" style={{ margin: 0 }}>{part.text}</p>
        ) : (
          <Box key={i} sx={{ display: 'flex', alignItems: 'baseline', gap: '5px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#9CA3AF', minWidth: 64, flexShrink: 0 }}>
              {part.field}
            </span>
            <span style={{ fontSize: 12, color: '#9CA3AF' }}>{part.from}</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#FABB00', flexShrink: 0 }}>{'→'}</span>
            <span style={{ fontSize: 13, fontWeight: 500, color: '#111827' }}>{part.to}</span>
          </Box>
        )
      )}
    </Box>
  );
};

const PackageHistoryTimelineRow = ({ event, color }: PackageHistoryTimelineRowProps) => {
  const config = TIPO_CONFIG[event.tipoMovimiento] ?? { label: event.tipoMovimiento, bg: '#f5f5f5' };
  const fecha = parseFecha(event.fecha);

  return (
    <Box id="timeline-row">
      <Grid container alignItems="center">
        <Grid item xs={4} md={3}>
          <Box className="date-container">
            <p className="date-label">
              {fecha.format('DD MMM YYYY').toUpperCase().replace('.', '')}
            </p>
          </Box>
        </Grid>
        <Grid item xs={8} md={9}>
          <Box className="description-container">
            <div className={`dot dot-${color}`} />
            <Box className="description-card">
              <Chip
                label={config.label}
                size="small"
                sx={{ backgroundColor: config.bg, mb: 1, fontFamily: 'Roboto', fontSize: 12 }}
              />
              {event.descripcion && (
                <DescripcionDiff descripcion={event.descripcion} />
              )}
              <p className="description-text">Por: {event.nombreUsuario}</p>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PackageHistoryTimelineRow;
